import { flagCache, clearCache, notifyObservers } from "./cache";
var debugActive = false;
var enableDebug = function() {
    if (!debugActive) {
        debugActive = true;
        // Attach console accessable entry point
        if (typeof window !== "undefined") {
            Object.assign(window, {
                ld_ff: {
                    flagCache: flagCache,
                    clearCache: clearCache,
                    notifyObservers: notifyObservers,
                    setOverride: setOverride
                }
            });
        }
    }
};
// Overrides prefix
var overridePrefix = "ld_override_";
var cacheKey = function(param) {
    var name = param.name, clientId = param.clientId;
    return overridePrefix + "_" + clientId + "_" + name;
};
var localStorageMock = function() {
    var store = {};
    return {
        getItem: function getItem(key) {
            return store[key] || null;
        },
        setItem: function setItem(key, value) {
            store[key] = value.toString();
        },
        clear: function clear() {
            store = {};
        },
        removeItem: function removeItem(key) {
            delete store[key];
        }
    };
}();
// Method to get an override from local storage
var getOverride = function(param) {
    var name = param.name, clientId = param.clientId;
    var _storage;
    var storage = typeof window === "undefined" ? localStorageMock : localStorage;
    var value = (_storage = storage) == null ? void 0 : _storage.getItem(cacheKey({
        name: name,
        clientId: clientId
    }));
    if (value) {
        return JSON.parse(value);
    }
    return null;
};
// Method to set an override in local storage
var setOverride = function(param) {
    var name = param.name, clientId = param.clientId, value = param.value;
    var _storage;
    var storage = typeof window === "undefined" ? localStorageMock : localStorage;
    (_storage = storage) == null ? void 0 : _storage.setItem(cacheKey({
        name: name,
        clientId: clientId
    }), JSON.stringify(value));
    notifyObservers(clientId);
};
export { enableDebug, debugActive, setOverride, getOverride };
